import AuthContext from "context/AuthContext";
import FormDataContainer from "./FormDataContainer";
import FormDataContainerBridge from "./FormDataContainerBridge";
import { useContext } from "react";
const FormDataContainerManager = () => {
    const { panel } = useContext(AuthContext);
    switch (panel.panel_type) {
        case "b":
            return <FormDataContainerBridge />;
        default:
            return <FormDataContainer />;
    }
};

export default FormDataContainerManager;